import { render, staticRenderFns } from "./bancada-emissao.vue?vue&type=template&id=de66fc62&"
import script from "./bancada-emissao.vue?vue&type=script&lang=js&"
export * from "./bancada-emissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports